import { render, staticRenderFns } from "./showDetail.vue?vue&type=template&id=60ca6ebc&"
import script from "./showDetail.vue?vue&type=script&lang=ts&"
export * from "./showDetail.vue?vue&type=script&lang=ts&"
import style0 from "./showDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports